import axios from 'axios';
import config from '../../constants/apiConfig';

type Base64PdfString = string;

export type ExportPaginatedIapDeps = {
  incident: unknown;
  user: unknown;
  groupGuid: string;
  /** Download / display stem (incident name + " IAP") */
  formnameStem: string;
  mapSketch?: any;
};

export async function postExportPaginatedIap(
  deps: ExportPaginatedIapDeps,
  periodNumber?: number
): Promise<{ downloadStem: string; data: string }> {
  const formData = new FormData();
  formData.append('formname', deps.formnameStem);
  formData.append('incident', JSON.stringify(deps.incident));
  formData.append('user', JSON.stringify(deps.user));
  formData.append('groupGuid', deps.groupGuid);
  if (periodNumber !== undefined) {
    formData.append('operationalPeriod', JSON.stringify(periodNumber));
  }
  if (deps.mapSketch != null) {
    formData.append('file', deps.mapSketch);
  }

  const response = await axios.post<Base64PdfString>(
    config.apiGateway.exportPaginatedIAP,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );

  return { downloadStem: deps.formnameStem, data: response.data || '' };
}
